export enum Colors {
  NO_APLICA_ID = '530327ff-7806-48d1-a97e-512c85b7dba1',
  NO_APLICA_NAME = 'No Aplica'
}
